export default __webpack_public_path__ + "static/media/Asset-25.f8b7463c.png";